import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllQuestions = () =>
  apiClient.get(REST_API_BASE_URL + '/questions');

export const saveQuestion = (question) =>
  apiClient.post(REST_API_BASE_URL + '/question', question);

export const getQuestion = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/question/${id}`);

export const updateQuestion = (id, question) =>
  apiClient.put(`${REST_API_BASE_URL}/question/${id}`, question);

export const deleteQuestion = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/question/${id}`);

export default apiClient;
